import React, { Fragment } from "react";

const LoadingGif = () => {
    return (
        <Fragment>
            <div className="loading">
                <img src="/gif/Floading.gif" alt="loading" className="standarFloading" />
            </div>
        </Fragment>
    );
};

export default LoadingGif;
